<div class="group-details-container w-full h-full {{this.screenSize}}">
  <form class="form items-center">
    <div class="heading-section flex flex-row justify-between items-center w-full">
      <div class="heading w-1/2">Schedule</div>
      <div class="action-section w-1/2 mt-[2rem] flex ">
        <div *ngIf="!groupId"
             class="flex w-full justify-end gap-[2rem]">
          <app-primary-button
            (handleClick)="onContinue()"
            class="save-btn xs:w-[35%] sm:w-[30%] md:w-[20%]"
            type="small"
          >
            Continue
          </app-primary-button>
          <app-icon
            *ngIf="this.groupId"
            (click)="deleteUser()"
            [svgIcon]="'delete'"
            class="delete-icon cursor-pointer"
          >
          </app-icon>
        </div>
        <div *ngIf="groupId && !isEditable"
             class="flex w-full justify-end gap-[2rem]">
          <app-primary-button
            (handleClick)="edit()"
            class="save-btn xs:w-[35%] sm:w-[30%] md:w-[20%]"
            type="small"
          >
            Edit
          </app-primary-button>
          <app-icon
            (click)="deleteUser()"
            [svgIcon]="'delete'"
            class="delete-icon cursor-pointer"
          >
          </app-icon>
        </div>
        <div *ngIf="isEditable"
             class="flex w-full justify-end gap-[2rem]">
          <app-primary-button
            (handleClick)="isSessionStartDateUpdated ? onContinue() : save()"
            class="edit xs:w-[35%] sm:w-[30%] md:w-[20%]"
            type="small"
          >
            {{ isSessionStartDateUpdated ? 'Continue' : 'Save' }}
          </app-primary-button>
          <app-icon
            (click)="deleteUser()"
            [svgIcon]="'delete'"
            class="delete-icon cursor-pointer"
          >
          </app-icon>
        </div>
      </div>
    </div>
    <hr class="line mt-[0.8rem]">
    <div
      class="schedule-details flex md:flex-row w-full justify-center items-center lg:px-[8rem] lg:pt-[3.2rem] md:space-x-[3rem] xs:space-x-0 sm:space-x-0 xs:flex-col sm:flex-col xs:px-0 xs:pt-[3.2rem] sm:px-0 sm:pt-[3.2rem] md:px-0 md:pt-[3.2rem]">
      <app-date-time-picker
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['sessionStartDateTime']"
        [min]="minimumDate"
        [parentFormGroup]="form"
        class=" input lg:w-[50%] xs:w-full sm:w-full"
        controlName="sessionStartDateTime"
        label="Session Start Date and Time"
        placeholder="Select a date time"
        type="small"
      ></app-date-time-picker>
      <div class="flex lg:flex-row lg:w-[50%] space-x-[3rem] xs:w-full sm:w-full">
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['sessionFormat']"
          [options]="sessionFormatOptions"
          [parentFormGroup]="form"
          class="input w-[70%]"
          controlName="sessionFormat"
          label="Group Format"
          placeholder="Select one"
          type="small"
        />
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['duration']"
          [max]="999"
          [parentFormGroup]="form"
          class="input w-[30%]"
          controlName="duration"
          label="Duration"
          suffixText="Mins"
          type="small"
        ></app-number-input>
      </div>
    </div>
    <div class="heading">Group Information</div>
    <hr class="line mt-[0.8rem]">
    <div
      class="group-details flex flex-col w-full justify-center items-center lg:px-[8rem] lg:pt-[3.2rem] xs:px-0 xs:pt-[3.2rem] sm:px-0 sm:pt-[3.2rem] md:px-0 md:pt-[3.2rem]">
      <div
        class="row flex md:flex-row w-full md:space-x-[3rem] xs:flex-col sm:flex-col xs:space-x-0 sm:space-x-0">
        <div [ngClass]="profileData?.role === roles.superAdmin ? 'lg:w-[50%]'
         : 'md:w-[75%] mb-[1.5rem]'"
             class="flex flex-col w-full">
          <div
            [ngClass]="profileData.role === roles.superAdmin ? 'justify-center' : 'justify-between'"
            class="flex flex-row space-x-[0.8rem] w-full items-center"
          >
            <app-text-input
              (checkForErrors)="checkForErrors($event)"

              [error]="errorMessages['name']"
              [maxLength]="validation.group.name.length.max"
              [minLength]="validation.group.name.length.min"
              [parentFormGroup]="form"
              [suffixIcon]="verifyStatusIcon"
              class="input input-groupname w-[65%]"
              controlName="name"
              label="Group Name"
              placeholder="Group Name"
              type="small"
            ></app-text-input>
            <div
              [class.action-section-error]="errorMessages['name'] && !displayErrorField"
              [class.action-section]="!errorMessages['name'] && !displayErrorField"
              [ngClass]="profileData.role !== roles.superAdmin ? 'w-[30%]' : 'w-[35%]'"
            >
              <app-primary-button
                (handleClick)="autoGenerateGroupName()"
                *ngIf="(!form.controls['name'].value || displayAutoGenerateButton); else verify"
                [isDisabled]="!form.controls['sessionStartDateTime'].value"
                [isLoading]="groupNameStatusLoading"
                class="generate-group-name w-full"
                type="small"
              >
                Autogenerate
              </app-primary-button>
              <ng-template #verify>
                <app-primary-button
                  (handleClick)="verifyGroupName()"
                  [isDisabled]="isVerifyDisabled || generatedGroupName == form.controls['name'].value"
                  [isLoading]="groupNameStatusLoading"
                  class="verify-group-name w-full"
                  type="small"
                >
                  Verify
                </app-primary-button>
              </ng-template>
            </div>
          </div>
          <div class="flex w-full">
            <div
              *ngIf="displayMessage"
              class="row flex flex-row w-full space-x-[2rem] justify-start items-center mb-[1rem] mt-[-1.3rem]"
            >
              <div
                *ngIf="groupNameStatusLoading; else loaded"
                class="loading text"
              >
                Loading...
              </div>
              <ng-template #loaded>
                <div
                  *ngIf="isGroupNameAvailable; else displayError"
                  class="success flex flex-row justify-center items-center space-x-[0.5rem]"
                >
                  <app-icon
                    svgIcon="check-circle"
                  ></app-icon>
                  <div class="text">Group name is available</div>
                </div>

                <ng-template #displayError>
                  <div
                    class="error flex flex-row justify-center items-center space-x-[0.5rem]"
                  >
                    <app-icon
                      svgIcon="exclamation-circle"
                    ></app-icon>
                    <div class="text">Group name is not available</div>
                  </div>
                </ng-template>
              </ng-template>
            </div>
          </div>
        </div>
        <app-search-on-select
          (checkForErrors)="checkForErrors($event)"
          (onClearSelection)="onClearSelection($event)"
          (onNextPage)="clientsOnNextPage()"
          *ngIf="profileData.role === roles.superAdmin"
          [enableClearSelection]="true"
          [error]="errorMessages['clientId']"
          [hasNext]="clientFilterDetails.hasNext"
          [loading]="clientFilterDetails.loading"
          [options]="clientFilterDetails.list"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="clientId"
          filterControlName="searchClient"
          label="Site/Organization"
          optionsPanelClassName="clients-dropdown"
          placeholder="Select one"
          type="small"
        ></app-search-on-select>
      </div>

      <div class="row flex md:flex-row w-full md:space-x-[3rem] xs:flex-col sm:flex-col xs:space-x-0 sm:space-x-0">
        <app-shimmer-loader
          *ngIf="groupFilterLoader;else groupStatusDropdown"
          [count]="1"
          [theme]="{'height': '5.6rem'}"
          appearance="line"
          class=" input lg:w-[50%] xs:w-full sm:w-full"
        >
        </app-shimmer-loader>
        <ng-template
          #groupStatusDropdown
        >
          <app-dropdown
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['status']"
            [options]="groupStatusOptions"
            [parentFormGroup]="form"
            class=" input lg:w-[50%] xs:w-full sm:w-full"
            controlName="status"
            label="Group Status"
            placeholder="Select one"
            type="small"
          />
        </ng-template>
        <div class="flex flex-col lg:w-[50%] xs:w-full sm:w-full">
          <div class="label">Type Of
            Group<span class="asterisk ml-[0.5rem]">*</span></div>
          <app-radio-input
            [error]="errorMessages['type']"
            [options]="radioFieldOptionForTypesOfGroup"
            [parentFormGroup]="form"
            controlName="type"
          ></app-radio-input>
        </div>
      </div>
      <div *ngIf="form.controls['type']?.value!==groupTypes.online"
           class="row flex md:flex-row w-full md:space-x-[3rem] xs:flex-col sm:flex-col xs:space-x-0 sm:space-x-0">
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          *ngIf="form?.controls?.addressLine1"
          [error]="errorMessages['addressLine1']"
          [maxLength]="validation.address.addressLine1.length.max"
          [minLength]="validation.address.addressLine1.length.min"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="addressLine1"
          label="Address"
          placeholder="Address"
          showCharCount="true"
          type="small"
        ></app-text-input>
        <div class="flex flex-row space-x-[1rem] lg:w-[50%] xs:w-full sm:w-full">
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="form?.controls?.city"
            [error]="errorMessages['city']"
            [maxLength]="validation.address.city.length.max"
            [minLength]="validation.address.city.length.min"
            [parentFormGroup]="form"
            class="input w-[50%]"
            controlName="city"
            label="City"
            placeholder="City"
            type="small"
          >
          </app-text-input>
          <app-dropdown
            (checkForErrors)="checkForErrors($event)"
            *ngIf="form?.controls?.state"
            [error]="errorMessages['state']"
            [options]="statesOptions"
            [parentFormGroup]="form"
            class="input w-[25%]"
            controlName="state"
            label="State"
            placeholder="--"
            type="small"
          />
          <app-number-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="form?.controls?.zipCode"
            [error]="errorMessages['zipCode']"
            [maxLength]="validation.address.zipCode.length.max"
            [parentFormGroup]="form"
            class="input w-[25%]"
            controlName="zipCode"
            label="Zip Code"
            placeholder="00000"
            type="small"
          ></app-number-input>
        </div>
      </div>
      <div class="row flex flex-row w-full">
        <app-text-area-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['note']"
          [maxLength]="validation.notes.length.max"
          [parentFormGroup]="form"
          class="input w-full"
          controlName="note"
          label="Notes"
          minLength="0"
          placeholder="Enter group notes here"
          showCharCount="true"
          type="small"
        ></app-text-area-input>
      </div>
    </div>

    <div class="heading">Measurements</div>
    <hr class="line mt-[0.8rem]">

    <div
      class="measurements-details flex w-full justify-start items-center lg:px-[8rem] lg:pt-[3.2rem] xs:px-0 xs:pt-[3.2rem] sm:px-0 sm:pt-[3.2rem] md:px-0 md:pt-[3.2rem]">
      <app-shimmer-loader
        *ngIf="measurementFilterLoader;else measurementFilterDropdown"
        [count]="1"
        [theme]="{'height': '5.6rem'}"
        appearance="line"
        class="input lg:w-[50%] xs:w-full sm:w-full"
      >
      </app-shimmer-loader>
      <ng-template
        #measurementFilterDropdown
      >
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [defaultValue]="defaultSelectedMeasurement"
          [enableClearSelection]="true"
          [enableMultiple]="true"
          [error]="errorMessages['metrics']"
          [options]="measurementOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="metrics"
          label="Capture Measurements"
          placeholder="Select Measurements"
          type="small"
        />

      </ng-template>

    </div>

    <div class="heading">Behavior Coaches</div>
    <hr class="line mt-[0.8rem]">

    <div
      class="coaches-details flex flex-col w-full justify-center items-center lg:px-[8rem] lg:pt-[3.2rem] xs:px-0 xs:pt-[3.2rem] sm:px-0 sm:pt-[3.2rem] md:px-0 md:pt-[3.2rem]">
      <div class="row flex sm:flex-row w-full sm:gap-[3rem] xs:flex-col xs:space-x-0">
        <app-filter-dropdown
          (checkForErrors)="checkForErrors($event)"
          (onNextPage)="fetchCoachNextPage()"
          [enableClearSelection]="true"
          [error]="errorMessages['adultCoach']"
          [hasNext]="coachesOptionsHasNext"
          [loading]="coachOptionsLoading"
          [options]="coachesOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="adultCoach"
          label="Adult Coach"
          placeholder="Select one"
          type="small"
        ></app-filter-dropdown>
        <app-filter-dropdown
          (checkForErrors)="checkForErrors($event)"
          (onNextPage)="fetchCoachNextPage()"
          [enableClearSelection]="true"
          [error]="errorMessages['childCoach']"
          [hasNext]="coachesOptionsHasNext"
          [loading]="coachOptionsLoading"
          [options]="coachesOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="childCoach"
          label="Child Coach"
          placeholder="Select one"
          type="small"
        ></app-filter-dropdown>
      </div>
      <div class="row flex sm:flex-row w-full sm:gap-[3rem] xs:flex-col xs:space-x-0">
        <app-filter-dropdown
          (checkForErrors)="checkForErrors($event)"
          (onNextPage)="fetchCoachNextPage()"
          [enableClearSelection]="true"
          [error]="errorMessages['substituteCoachOne']"
          [hasNext]="coachesOptionsHasNext"
          [loading]="coachOptionsLoading"
          [options]="coachesOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="substituteCoachOne"
          label="Substitute Coach (Any)"
          placeholder="Select one"
          type="small"
        ></app-filter-dropdown>
        <app-filter-dropdown
          (checkForErrors)="checkForErrors($event)"
          (onNextPage)="fetchCoachNextPage()"
          [enableClearSelection]="true"
          [error]="errorMessages['substituteCoachTwo']"
          [hasNext]="coachesOptionsHasNext"
          [loading]="coachOptionsLoading"
          [options]="coachesOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="substituteCoachTwo"
          label="Substitute Coach (Any)"
          placeholder="Select one"
          type="small"
        ></app-filter-dropdown>
      </div>
      <div class="row flex sm:flex-row w-full sm:gap-[3rem] xs:flex-col xs:space-x-0">
        <app-filter-dropdown
          (checkForErrors)="checkForErrors($event)"
          (onNextPage)="fetchCoachNextPage()"
          [enableClearSelection]="true"
          [error]="errorMessages['substituteCoachThree']"
          [hasNext]="coachesOptionsHasNext"
          [loading]="coachOptionsLoading"
          [options]="coachesOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="substituteCoachThree"
          label="Substitute Coach (Any)"
          placeholder="Select one"
          type="small"
        ></app-filter-dropdown>
        <app-filter-dropdown
          (checkForErrors)="checkForErrors($event)"
          (onNextPage)="fetchCoachNextPage()"
          [enableClearSelection]="true"
          [error]="errorMessages['substituteCoachFour']"
          [hasNext]="coachesOptionsHasNext"
          [loading]="coachOptionsLoading"
          [options]="coachesOptions"
          [parentFormGroup]="form"
          class="input lg:w-[50%] xs:w-full sm:w-full"
          controlName="substituteCoachFour"
          label="Substitute Coach (Any)"
          placeholder="Select one"
          type="small"
        ></app-filter-dropdown>
      </div>
    </div>

    <div class="heading">Eligibility Criteria</div>
    <hr class="line mt-[0.8rem]">
    <div
      class="eligibility-criteria flex lg:flex-row w-full justify-center items-center lg:px-[8rem] lg:pt-[3.2rem] gap-[2rem] xs:flex-col sm:flex-col md:flex-col xs:px-0 xs:pt-[3.2rem] sm:px-0 sm:pt-[3.2rem] md:px-0 md:pt-[3.2rem]">
      <div class="minimum-bmi flex flex-col lg:w-[60%] xs:w-full sm:w-full md:w-full">
        <div class="label">Minimum BMI</div>
        <div class="flex w-full flex-row space-x-[1rem]">
          <app-radio-input
            [error]="errorMessages['minimumBmi']"
            [options]="radioFieldOptionForMinimumBmi"
            [parentFormGroup]="form"
            class="minimum-bmi-input radio-input flex items-center xs:w-[28%] sm:w-[25%] md:w-[15rem]"
            controlName="minimumBmi"
          ></app-radio-input>
          <app-number-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="form?.controls?.customBmi"
            [error]="errorMessages['customBmi']"
            [maxLength]="validation.group.customBmi.length.max"
            [max]="99"
            [parentFormGroup]="form"
            class="input only-number custom-bmi flex xs:w-[6rem] sm:w-[5rem] xs:items-end sm:items-end lg:items-start xs:mb-[0.48rem] lg:mb-0"
            controlName="customBmi"
            type="small"
          ></app-number-input>
        </div>
      </div>
      <div class="participant-age flex flex-col lg:w-[37%] xs:w-full sm:w-full md:w-full">
        <div class="label justify-start items-center">Participant Age</div>
        <div class="flex flex-row justify-start items-center gap-[0.5rem]">
          <div [class.sub-label-disabled]="form.disabled"
               class="sub-label">>=
          </div>
          <app-number-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['minParticipantAge']"
            [maxLength]="validation.group.participantAge.length.max"
            [max]="99"
            [parentFormGroup]="form"
            class="input only-number w-[5rem]"
            controlName="minParticipantAge"
            placeholder="00"
            type="small"
          ></app-number-input>
          <div [class.sub-label-disabled]="form.disabled"
               class="sub-label">Years To <
          </div>
          <app-number-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['maxParticipantAge']"
            [maxLength]="validation.group.participantAge.length.max"
            [max]="99"
            [parentFormGroup]="form"
            class="input only-number w-[5rem]"
            controlName="maxParticipantAge"
            placeholder="00"
            type="small"
          ></app-number-input>
          <div [class.sub-label-disabled]="form.disabled"
               class="sub-label">Years
          </div>
        </div>
        <div *ngIf="errorMessages['maxParticipantAge']"
             class="error-max-age-participant">
          {{ errorMessages['maxParticipantAge'] }}
        </div>
      </div>

    </div>

    <div class="heading pt-[1rem]">Costs</div>
    <hr class="line mt-[0.8rem]">

    <div
      class="cost-details flex sm:flex-row w-full justify-start items-center lg:px-[8rem] lg:pt-[3.2rem] sm:space-x-[3rem] xs:space-x-0 xs:flex-col xs:px-0 xs:pt-[3.2rem] sm:px-0 sm:pt-[3.2rem] md:px-0 md:pt-[3.2rem]">
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['fee']"
        [parentFormGroup]="form"
        class="input sm:w-[20%] xs:w-full"
        controlName="fee"
        label="Fee"
        placeholder="00.00"
        prefixIcon="dollar-sign"
        type="small"
      ></app-number-input>
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['deposit']"
        [parentFormGroup]="form"
        class="input sm:w-[20%] xs:w-full"
        controlName="deposit"
        label="Deposit"
        placeholder="00.00"
        prefixIcon="dollar-sign"
        type="small"
      ></app-number-input>
      <div class="flex flex-col sm:w-[25%] pb-[1.5rem] xs:w-full">
        <div class="label">Financial Aid Accepted</div>
        <app-radio-input
          [error]="errorMessages['financialAidAccepted']"
          [options]="radioFieldOptionForFinancialAidAccepted"
          [parentFormGroup]="form"
          controlName="financialAidAccepted"
        ></app-radio-input>
      </div>
    </div>

    <hr class="line mt-[1rem]">
  </form>
</div>

